import { render, staticRenderFns } from "./MostReadArticlesItem.vue?vue&type=template&id=211065de&"
import script from "./MostReadArticlesItem.vue?vue&type=script&lang=js&"
export * from "./MostReadArticlesItem.vue?vue&type=script&lang=js&"
import style0 from "./MostReadArticlesItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports